/**
 * RTC provider selection (CORE-393). Every RTC token response carries an
 * optional `provider` field; the FE picks its SDK from it, defaulting to Agora
 * so responses from older backends (no field) keep working unchanged.
 */
export type RtcProvider = 'agora' | 'livekit';

export function selectRtcProvider(
  token: { provider?: RtcProvider | string | null } | null | undefined,
): RtcProvider {
  return token?.provider === 'livekit' ? 'livekit' : 'agora';
}
